import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";

type JobBenchmarkingContextType = {
  showMatched: {
    task: boolean;
    competency: boolean;
  };
  setShowMatched: Dispatch<
    SetStateAction<{
      task: boolean;
      competency: boolean;
    }>
  >;
  showUnmatched: {
    task: boolean;
    competency: boolean;
  };
  setShowUnmatched: Dispatch<
    SetStateAction<{
      task: boolean;
      competency: boolean;
    }>
  >;
  showAccompaniedCompetencies: {
    competency: boolean;
  };
  setShowAccompaniedCompetencies: Dispatch<
    SetStateAction<{
      competency: boolean;
    }>
  >;
  resetToDefault: () => void;
};

export const JobBenchmarkingContext = createContext<JobBenchmarkingContextType>({
  showMatched: {
    task: false,
    competency: false
  },
  setShowMatched: () => {},
  showUnmatched: {
    task: false,
    competency: false
  },
  setShowUnmatched: () => {},
  showAccompaniedCompetencies: {
    competency: false
  },
  setShowAccompaniedCompetencies: () => {},
  resetToDefault: () => {}
});

export const JobBenchmarkingProvider = ({ children }: { children: ReactNode }) => {
  const [showMatched, setShowMatched] = useState({
    task: false,
    competency: false
  });
  const [showUnmatched, setShowUnmatched] = useState({
    task: false,
    competency: false
  });
  const [showAccompaniedCompetencies, setShowAccompaniedCompetencies] = useState({
    competency: false
  });

  const resetToDefault = () => {
    setShowMatched({
      task: false,
      competency: false
    });

    setShowUnmatched({
      task: false,
      competency: false
    });

    setShowAccompaniedCompetencies({
      competency: false
    });
  };

  return (
    <JobBenchmarkingContext.Provider
      value={{
        showMatched,
        setShowMatched,
        showUnmatched,
        setShowUnmatched,
        showAccompaniedCompetencies,
        setShowAccompaniedCompetencies,
        resetToDefault
      }}
    >
      {children}
    </JobBenchmarkingContext.Provider>
  );
};
